"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  SelectionFilter: true
};
exports.default = exports.SelectionFilter = void 0;
var _react = _interopRequireWildcard(require("react"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _isEnterOrSpace = require("../utils/isEnterOrSpace");
var _useUpdatesOnlyEffect = require("../utils/useUpdatesOnlyEffect");
var _IconButton = require("../IconButton/IconButton");
var _Icon = require("../Icon/Icon");
var _InputField = require("../InputField/InputField");
var _Select = require("../Select/Select");
var _SelectDialogContext = require("./_SelectDialogContext");
var _SelectionFilter = require("./_SelectionFilter.types");
Object.keys(_SelectionFilter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SelectionFilter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SelectionFilter[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const SelectionFilter = exports.SelectionFilter = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  var _a, _b, _c, _d, _e, _f;
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const _g = addChildProps ? Object.assign(Object.assign({}, props), addChildProps(SelectionFilter, props)) : props,
    {
      filterLabel,
      filterIconProps,
      filterType,
      filterDropdownItemKey = 'key',
      filterDropdownItemText = 'text',
      filterDropdownOptions,
      filterDropdownLabel,
      filterDropdownSelectedKey,
      filterDropdownOnSelect,
      filterDropdownRef: _filterDropdownRef,
      filterDropdownComponentProps,
      filterDropdownDataRendering,
      itemCount,
      itemCountScreenReaderLabel,
      noItemsScreenReaderLabel,
      manualFilterButtonProps,
      onFilter
    } = _g,
    otherProps = __rest(_g, ["filterLabel", "filterIconProps", "filterType", "filterDropdownItemKey", "filterDropdownItemText", "filterDropdownOptions", "filterDropdownLabel", "filterDropdownSelectedKey", "filterDropdownOnSelect", "filterDropdownRef", "filterDropdownComponentProps", "filterDropdownDataRendering", "itemCount", "itemCountScreenReaderLabel", "noItemsScreenReaderLabel", "manualFilterButtonProps", "onFilter"]);
  const manualFilter = filterType === 'manual' && (manualFilterButtonProps === null || manualFilterButtonProps === void 0 ? void 0 : manualFilterButtonProps.ariaLabel);
  const {
    showSelectDialog
  } = (0, _react.useContext)(_SelectDialogContext.SelectDialogContext) || {};
  const [selectedKey, setSelectedKey] = (0, _react.useState)(filterDropdownSelectedKey);
  const [filterString, setFilterString] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    setSelectedKey(filterDropdownSelectedKey);
  }, [filterDropdownSelectedKey]);
  const handleFilterClick = () => {
    onFilter === null || onFilter === void 0 ? void 0 : onFilter(filterString);
  };
  const handleSelect = (_, eventKey) => {
    setSelectedKey(eventKey);
    filterDropdownOnSelect === null || filterDropdownOnSelect === void 0 ? void 0 : filterDropdownOnSelect(eventKey);
  };
  (0, _useUpdatesOnlyEffect.useUpdatesOnlyEffect)(() => {
    if (!manualFilter) {
      handleFilterClick();
    }
  }, [filterString]);
  const iconSizeMap = {
    lg: 'sm-plus',
    md: 'sm'
  };
  const filterIcon = /*#__PURE__*/_react.default.createElement(_Icon.Icon, Object.assign({
    ariaHidden: true,
    iconName: "search",
    size: iconSizeMap[(_a = otherProps === null || otherProps === void 0 ? void 0 : otherProps.size) !== null && _a !== void 0 ? _a : 'lg']
  }, filterIconProps));
  const inputStartDecorators = _react.default.Children.toArray((_b = otherProps === null || otherProps === void 0 ? void 0 : otherProps.decorators) === null || _b === void 0 ? void 0 : _b.inputStart);
  if (filterDropdownOptions) {
    inputStartDecorators.push(/*#__PURE__*/_react.default.createElement(_Select.Select, Object.assign({}, filterDropdownComponentProps, {
      dataRendering: filterDropdownDataRendering,
      itemKey: filterDropdownItemKey,
      itemText: filterDropdownItemText,
      label: filterDropdownLabel,
      screenReaderOnlyLabel: true,
      options: filterDropdownOptions,
      selectedKey: selectedKey,
      onSelect: handleSelect
    })));
  }
  let itemCountMessage = '';
  if (filterString && showSelectDialog) {
    if (itemCount === 0 && noItemsScreenReaderLabel) {
      itemCountMessage = noItemsScreenReaderLabel;
    }
    if (itemCount > 0) {
      itemCountMessage = `${itemCountScreenReaderLabel} ${itemCount}`;
    }
  }
  return /*#__PURE__*/_react.default.createElement(_InputField.InputField, Object.assign({
    screenReaderOnlyLabel: true,
    enableScreenReaderStatus: !(otherProps === null || otherProps === void 0 ? void 0 : otherProps.disabled) && !(otherProps === null || otherProps === void 0 ? void 0 : otherProps.readOnly),
    screenReaderMessage: itemCountMessage
  }, otherProps, {
    ref: ref,
    label: filterLabel,
    placeholder: filterLabel,
    onBlur: (0, _chainFunction.default)(otherProps === null || otherProps === void 0 ? void 0 : otherProps.onBlur, (_c = otherProps === null || otherProps === void 0 ? void 0 : otherProps.inputProps) === null || _c === void 0 ? void 0 : _c.onBlur),
    onChange: (0, _chainFunction.default)(event => {
      var _a;
      setFilterString((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value);
    }, otherProps === null || otherProps === void 0 ? void 0 : otherProps.onChange, (_d = otherProps === null || otherProps === void 0 ? void 0 : otherProps.inputProps) === null || _d === void 0 ? void 0 : _d.onChange),
    onFocus: (0, _chainFunction.default)(otherProps === null || otherProps === void 0 ? void 0 : otherProps.onFocus, (_e = otherProps === null || otherProps === void 0 ? void 0 : otherProps.inputProps) === null || _e === void 0 ? void 0 : _e.onFocus),
    onKeyDown: (0, _chainFunction.default)(event => {
      if (manualFilter && event && event.keyCode === 13) {
        handleFilterClick();
      }
    }, otherProps === null || otherProps === void 0 ? void 0 : otherProps.onKeyDown),
    value: filterString,
    decorators: Object.assign(Object.assign({}, otherProps === null || otherProps === void 0 ? void 0 : otherProps.decorators), {
      inputStart: inputStartDecorators,
      inputEnd: [..._react.default.Children.toArray((_f = otherProps === null || otherProps === void 0 ? void 0 : otherProps.decorators) === null || _f === void 0 ? void 0 : _f.inputEnd), ...(manualFilter ? [/*#__PURE__*/_react.default.createElement(_IconButton.IconButton, Object.assign({}, manualFilterButtonProps, {
        ariaLabel: (manualFilterButtonProps === null || manualFilterButtonProps === void 0 ? void 0 : manualFilterButtonProps.ariaLabel) || '',
        iconName: "search",
        iconProps: filterIconProps,
        onClick: (0, _chainFunction.default)(handleFilterClick, manualFilterButtonProps === null || manualFilterButtonProps === void 0 ? void 0 : manualFilterButtonProps.onClick),
        onKeyDown: (0, _chainFunction.default)(event => {
          if ((0, _isEnterOrSpace.isEnterOrSpace)(event)) {
            handleFilterClick();
            event.preventDefault();
          }
        }, manualFilterButtonProps === null || manualFilterButtonProps === void 0 ? void 0 : manualFilterButtonProps.onKeyDown)
      }))] : [filterIcon])]
    })
  }));
});
SelectionFilter.displayName = 'SelectionFilter';
var _default = exports.default = SelectionFilter;